import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
// MSAL imports
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser';

import { configureAdminFetch } from './api/adminFetch';
import { createApiSession } from './auth/apiSession';
import App from './App';
import { apiScopes, msalConfig } from './authConfig';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';

export const msalInstance = new PublicClientApplication(msalConfig);
const apiSession = createApiSession(msalInstance, apiScopes);
configureAdminFetch(apiSession);

const root = createRoot(document.querySelector('#root') as HTMLElement);

async function bootstrap() {
  try {
    await msalInstance.initialize();
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    const accounts = msalInstance.getAllAccounts();
    if (!msalInstance.getActiveAccount() && accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }

    msalInstance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
      }
    });

    root.render(
      <Router>
        <App pca={msalInstance} apiSession={apiSession} />
      </Router>,
    );
  } catch {
    root.render(
      <main role="alert">
        Unable to start sign-in. Please reload the page to try again.
      </main>,
    );
  }
}

// Vite's browser target does not support top-level await.
// eslint-disable-next-line unicorn/prefer-top-level-await
void bootstrap();
